// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__Wk35a","group":"List_group__hmn_3","title":"List_title__161zW"};